import { parseDate } from "../utilities/parseHelper";
import { correctFIO } from "../utilities/parseHelper";
import { DateType, Dictionary } from "./types/index";

/**  Класс для данных персоны. */
export class PersonInfoData {
  /** Логин. */
  public Login: string = "";

  /** Алиас. */
  public Alias: string = "";

  /** Фамилия. */
  public Surname: string = "";

  /** Имя. */
  public Name: string = "";

  /** Отчество. */
  public Patronymic: string = "";

  /** Электронная почта. */
  public EMail: string = "";

  /** Мобильный телефон. */
  public MobileTel: string = "";

  /** ИД персоны в ДБО. */
  public Id = 0;

  /** Reference персоны в ДБО. */
  public ReferenceId: string = "";

  /** Роль доступа в ДБО. */
  public AccessRole = 0;

  /** СНИЛС персоны в ДБО. */
  public Snils: string = "";

  /** ИНН персоны в ДБО. */
  public Inn: string = "";

  /** Номер основного документа. */
  public MainDocNumber: string = "";

  /** Адрес регистрации. */
  public RegAddress: string = "";

  /** Признак режима. */
  public Mode = 0;

  /** Разрешены входящие переводы СБП. */
  public EnableSbpIn = false;

  /** Разрешены исходящие переводы СБП. */
  public EnableSbpOut = false;

  /** Согласие на СБП уже было. */
  public SbpAccept = false;

  /** Время согласия с ДКБО. */
  public AcceptedRulesTime: DateType = null;

  /** Время согласия с ДКБО. */
  public AcceptedKDBOTime: DateType = null;

  /** РефИД счета по умолчанию для зачислений. */
  public DefaultInAccount: string = "";

  /** РефИД счета по умолчанию для зачислений. */
  public DefaultOutAccount: string = "";

  /** Смс пакет. */
  public SmsPacketId: string = "";

  /** Аватар пользователя в Base64String */
  public Avatar: string = "";

  /** Признак vip клиента */
  public Vip: boolean = false;

  public CustomFields: Dictionary<string> = {};

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      this.Id = src.Id ?? 0;
      this.Login = src.Login ?? "";
      this.Alias = src.Alias ?? "";
      this.ReferenceId = src.ReferenceId ?? "";
      this.Surname = correctFIO(src.Surname ?? "");
      this.Name = correctFIO(src.Name ?? "");
      this.Patronymic = correctFIO((src.Patronymic || src.SecondName) ?? "");
      this.EMail = src.EMail ?? "";
      this.MobileTel = src.MobileTel ?? "";
      this.AccessRole = src.AccessRole ?? 0;
      this.Snils = src.Snils ?? "";
      this.Inn = src.Inn ?? "";
      if (this.Inn === "0") this.Inn = "";
      this.MainDocNumber = src.MainDocNumber ?? "";
      this.RegAddress = src.RegAddress ?? "";
      this.Mode = src.Mode ?? 0;
      this.EnableSbpIn = src.EnableSbpIn ?? false;
      this.EnableSbpOut = src.EnableSbpOut ?? false;
      this.SbpAccept = src.SbpAccept ?? false;
      this.AcceptedRulesTime = parseDate(src.AcceptedRulesTime);
      this.AcceptedKDBOTime = parseDate(src.AcceptedKDBOTime);
      this.DefaultInAccount = src.DefaultInAccount ?? "";
      this.DefaultOutAccount = src.DefaultOutAccount ?? "";
      this.SmsPacketId = src.SmsPacketId ?? "";
      this.Avatar = src.Avatar ?? "";
      this.Vip = src.Vip ?? false;

      const sXml: string = src.CustomFields ?? "";

      // Парсим XML.
      const parser = new DOMParser();
      const xDoc = parser.parseFromString(sXml, "text/xml");

      const xmlFields = xDoc.getElementsByTagName('Field');

      for (let i = 0; i < xmlFields.length; i++) {
        const field = xmlFields[i];
        const key = xmlFields[i].getAttribute('name');
        const val = xmlFields[i].getAttribute('value');
        if (key && val) {
          this.CustomFields[key] = val;
        }
      }
    }
  }
}
